<!-- <div class="modal-content" style="height: 95vh;">
  <div class="modal-header" id="social-share-btns-modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
      <div class="modal-info" id="social-share-btns-body">
        <div class="row p-3">
          <div class="post-img-preview">
            <img src="{{baseUrl}}{{image}}" alt="post image">
          </div>
        </div>
      <div class="row mt-3">
          <div class="col-12 text-right">
              <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="bsModalRef.hide()" data-toggle="modal">Close</button>
          </div>
      </div>
      </div>
  </div>
</div> -->
<div class="modal-header">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="post-img-preview">
  <img src="{{baseUrl}}{{image}}" alt="post image">
</div>
